import { render, staticRenderFns } from "./FeaturedPosts.vue?vue&type=template&id=76a178eb&scoped=true"
import script from "./FeaturedPosts.vue?vue&type=script&lang=js"
export * from "./FeaturedPosts.vue?vue&type=script&lang=js"
import style0 from "./FeaturedPosts.vue?vue&type=style&index=0&id=76a178eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a178eb",
  null
  
)

export default component.exports